import React, { useEffect, useRef, useState } from "react";
// import ImageMarker from "react-image-marker";
import { Face1, Face2, Face3, Face4 } from "../../../assets/images";
// import Draggable from "react-draggable";
import "./styles.css";
import { getDrawtool } from "../../../apis/drawtool";
import { toastify } from "../../../helperFunctions/toastify";
// import html2canvas from "html2canvas";
// import "tui-image-editor/dist/tui-image-editor.css";
// import ImageEditor from "@toast-ui/react-image-editor";
import FilerobotImageEditor, {
	TABS,
	TOOLS,
} from "react-filerobot-image-editor";

export default function Drawtool() {
	const [markers, setMarkers] = useState([]);
	const [faces, setFaces] = useState([]);
	const [selectedFace, setSelectedFace] = useState();
	// const [activeDrags, setActiveDrags] = useState(0);
	const [drags, setDrags] = useState([]);
	const [captions, setCaptions] = useState([]);
	const [text, setText] = useState("");
	const [tab, setTab] = useState("");
	const [preview, setPreview] = useState();

	const editorProps = {
		includeUI: {
			menu: ["text", "draw", "crop", "flip", "rotate"],
			initMenu: "draw",
			uiSize: {
				width: "1000px",
				height: "700px",
			},
			menuBarPosition: "bottom",
			loadImage: {
				name: "Face",
				path: selectedFace
					? selectedFace.imageUrl
					: "https://bluesilo-epion.s3.ap-southeast-1.amazonaws.com/Face%203.png",
			},
		},
		// cssMaxHeight={500}
		cssMaxWidth: 400,
		selectionStyle: {
			cornerSize: 20,
			rotatingPointOffset: 70,
		},
		usageStatistics: true,
	};

	const CustomMarker = (props) => {
		return <div className="drawtool-marker"></div>;
	};

	const undo = () => {
		let _markers = [...markers];
		_markers.pop();
		setMarkers(_markers);
	};

	const createTextbox = () => {
		if (text && text !== "") {
			let _text = [...captions];
			_text.push(text);
			setText("");
			setCaptions(_text);
			setTab("");
		}
	};

	const changeFace = (e) => {
		setSelectedFace(e);
		setMarkers([]);
		setCaptions([]);
		console.log({ selectedFace: e });
		const image = document.createElement("img");
		image.setAttribute("src", e.imageUrl);
		setPreview(image);
		console.log({ image });
	};

	const populateTemplates = async () => {
		const response = await getDrawtool();
		if (response?.status !== "Fail") {
			setFaces(response || []);
		} else {
			if (response?.message === "No data Found") {
				setFaces([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	useEffect(() => {
		populateTemplates();
	}, []);

	return (
		<div className="p-0 mb-5 pb-5 h-100">
			<div className="mainHeading px-4">
				<h1>Drawtool Template</h1>
			</div>

			<div className="image-container-1 pb-4">
				{faces &&
					faces?.length > 0 &&
					faces?.map((e, i) => (
						<div
							key={i}
							className="d-flex p-2 mx-3 h-100"
							style={{ border: "1px solid gray" }}
						>
							<img
								src={e.imageUrl}
								alt="img"
								className="drawtool-images"
								onClick={() => {
									changeFace(e);
								}}
							/>
						</div>
					))}
			</div>

			<div className="drag-container">
				{/* {selectedFace && (
          <div className="editor">
            <div
              className={
                tab === "cursor" ? "editor-icon-active" : "editor-icon-inactive"
              }
              onClick={() => {
                setTab("cursor");
              }}
            >
              <i class="fa-solid fa-arrow-pointer"></i>
            </div>

            <div
              className={
                tab === "pen" ? "editor-icon-active" : "editor-icon-inactive"
              }
              onClick={() => {
                if (tab !== "pen") {
                  setTab("pen");
                } else {
                  setTab("");
                }
              }}
            >
              <i class="fa-solid fa-pen"></i>
            </div>

            <div
              className={
                tab === "text" ? "editor-icon-active" : "editor-icon-inactive"
              }
              onClick={() => {
                if (tab !== "text") {
                  setTab("text");
                } else {
                  setTab("");
                }
              }}
            >
              <i class="fa-solid fa-font"></i>
            </div>

            <div
              className={
                tab === "zoomin" ? "editor-icon-active" : "editor-icon-inactive"
              }
              onClick={() => {
                setTab("zoomin");
              }}
            >
              <i class="fa-solid fa-magnifying-glass-plus"></i>
            </div>

            <div
              className={
                tab === "zoomout"
                  ? "editor-icon-active"
                  : "editor-icon-inactive"
              }
              onClick={() => {
                setTab("zoomout");
              }}
            >
              <i class="fa-solid fa-magnifying-glass-minus"></i>
            </div>

            <div
              className={
                tab === "reset" ? "editor-icon-active" : "editor-icon-inactive"
              }
              onClick={() => {
                setMarkers([]);
                setCaptions([]);
                setTab("reset");
              }}
            >
              <i class="fa-solid fa-xmark"></i>
            </div>
            <div
              className={
                tab === "undo" ? "editor-icon-active" : "editor-icon-inactive"
              }
              onClick={() => {
                undo();
                setTab("undo");
              }}
            >
              <i class="fa-solid fa-rotate-left"></i>
            </div>
          </div>
        )} */}
				<div
					className={`${
						tab === "zoomin" || tab === "pen"
							? "zoom-kro"
							: "na-kro"
					}`}
				>
					{/* {selectedFace && (
            <div className="d-flex justify-content-center" id="typehead">
              <div
                style={{
                  width: 300,
                  cursor: tab === "pen" ? "crosshair" : "auto",
                  border: "1px solid gray",
                  backgroundImage: selectedFace.imageUrl,
                  backgroundColor: "transparent",
                }}
                className={
                  // tab === "pen" ? "marker-extra-zoomin" :
                  "marker-extra-zoomout"
                }
                id="capture"
              >
                <ImageMarker
                  src={selectedFace.imageUrl}
                  markers={markers}
                  onAddMarker={(marker) => {
                    if (tab === "pen") {
                      setMarkers([...markers, marker]);
                    }
                  }}
                  markerComponent={CustomMarker}
                  bufferLeft={tab === "zoomin" || tab === "pen" ? "10" : "5"}
                  bufferTop={tab === "zoomin" || tab === "pen" ? "10" : "5"}
                  alt="image"
                />
              </div>
            </div>
          )} */}

					{selectedFace && (
						<div
							style={{
								width: window.innerWidth > 1280 ? 1500 : 1000,
							}}
						>
							{/* <ImageEditor {...editorProps} /> */}
							<FilerobotImageEditor
								// source={selectedFace.imageUrl}
								source={preview}
								// source={
								//   "https://scaleflex.airstore.io/demo/stephen-walker-unsplash.jpg"
								// }
								onSave={(editedImageObject, designState) => {
									console.log("SUCCESS", {
										editedImageObject,
										designState,
									});
									toastify(
										"Image Saved Successfully",
										"success",
									);
									setSelectedFace();
								}}
								annotationsCommon={{
									fill: "#000000",
									stroke: "#000000",
									strokeWidth: 1,
								}}
								Text={{ text: "Write..." }}
								// disableZooming
								Rotate={{ angle: 90, componentType: "slider" }}
								tabsIds={["Annotate"]}
								defaultTabId={TABS.ANNOTATE}
								defaultToolId={TOOLS.TEXT}
							/>
						</div>
					)}

					{/* {tab === "text" && (
            <input
              placeholder="Write..."
              className="textbox-class"
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  createTextbox();
                }
              }}
              onBlur={() => {
                createTextbox();
              }}
            />
          )} */}

					{/* {captions?.map((e, i) => (
            <Draggable
              key={i}
              bounds="parent"
              // {...dragHandlers}
              defaultPosition={{
                x: 480,
                y: -200,
              }}
              onDrag={(e) => {
                let _drags = [...drags];
                let index = _drags.findIndex(
                  (f) => f.text === e.path[0].innerText
                );
                if (index != -1) {
                  _drags[index] = {
                    text: e.path[0].innerText,
                    x: e.screenX,
                    y: e.screenY,
                  };
                  setDrags(_drags);
                } else {
                  _drags.push({
                    text: e.path[0].innerText,
                    x: e.screenX,
                    y: e.screenY,
                  });
                  setDrags(_drags);
                }
              }}
            >
              <div className="box1">
                <div className={`box1-zoomout`}>{e}</div>
              </div>
            </Draggable>
          ))} */}
				</div>
			</div>
		</div>
	);
}
